import { useLocation, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@/lib/auth-context";
import { Sidebar } from "./DashboardLayout.sidebar";

export const DashboardLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && !isAuthenticated && location.pathname !== "/login") {
      window.location.href = "/login";
    }
  }, [isLoading, isAuthenticated, navigate]);

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex items-center space-x-2">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  // Don't render the main layout if not authenticated
  if (!isAuthenticated && location.pathname !== "/login") {
    return null;
  }

  if (location.pathname === "/login") {
    return children;
  }

  return (
    <div className="min-h-screen bg-background">
      {/* Mobile Header */}

      {/* Desktop Layout */}
      <div className="lg:flex">
        <Sidebar />
        <main className="flex-1 lg:pl-72 w-full">
          <div className="container mx-auto px-4 py-8 w-full">{children}</div>
        </main>
      </div>

      <div className="lg:hidden mb-12">
        <Sidebar />
      </div>
    </div>
  );
};
